/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getInstrumentLinksApp} from '../api'

 export const useQueryGetInstrumentLinksApp = createReactQueryHook('getInstrumentLinksApp', getInstrumentLinksApp)
